import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import Loader from 'components/Loader';
import useImagePreloader from 'hooks/usePreloadImages';

import * as images from 'assets/images';
import dayjs from 'dayjs';
import { ModalStyle, Wrapper } from './styles';
// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = ({ children }) => {
    const [isOepnModal, setIsOpenModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const { isPreloaded } = useImagePreloader([...Object.values(images)]);

    useEffect(() => {
        const isCompaignEnd = dayjs().isAfter(dayjs('2024-08-08', 'YYYY-MM-DD').endOf('day'));
        if (isCompaignEnd) setIsOpenModal(true);

        setLoading(!isPreloaded);
    }, [isPreloaded]);

    return (
        <Wrapper className="hide-scroll-bar">
            {loading ? <Loader /> : children}
            <ModalStyle open={isOepnModal}>
                <Box className="modal-body">
                    <div className="modal-main-body">
                        <Typography variant="h2" align="center" mt={2}>
                            活動已結束
                        </Typography>
                        <Box className="modal-content hide-scroll-bar">
                            <Typography variant="body2" align="center" mt={2} mb={4}>
                                {'謝謝您的參與，期待未來在其他活動與您相見！'}
                            </Typography>
                        </Box>
                    </div>
                </Box>
            </ModalStyle>
        </Wrapper>
    );
};

MainLayout.propTypes = {};

export default MainLayout;
